"use strict";
angular.module("showNetWorkModule", ['tManageMentServiceModule'])
    .controller("showNetWorkCtrl", ["$scope", "$sce", "$modalInstance", "item", "trsHttpService", "modalDialog", "$validation", function($scope, $sce, $modalInstance, item, trsHttpService, modalDialog, $validation) {
        initStatus();
        initData();
        /** [initData description]初始化数据 */
        function initData() {
            $scope.data = {
                content: $sce.trustAsHtml(item.CONTENT.replace(/\n/g, "<br/>")),
                title: item.TITLE
            };
        }
        /** [initStatus description]初始化状态 */
        function initStatus() {

        }
        /** [cancel description] 关闭弹窗*/
        $scope.confirm = function() {
            $modalInstance.dismiss();
        };
        /** [cancel description] 关闭弹窗*/
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);